import Vue from "vue"
import {
  INIT_MENU,
  ENABLE_MENU_ACTIVE,
  DISABLE_MENU_ACTIVE,
  SET_MODULES,
  UPDATE_MENU,
  SET_APPLICATION,
  UPDATE_MODULE,
  SET_MODULE_TYPES,
  SET_OTHER_MODULE_TYPES,
  SET_SYSTEM_MODULES,
  SET_LIST_PAGE_TYPES,
  SET_DETAIL_PAGE_TYPES
} from "./mutation-types"

export default {
  [INIT_MENU](state) {},
  [ENABLE_MENU_ACTIVE](state, { i }) {
    state.menu.children[i].isActive = true
  },
  [DISABLE_MENU_ACTIVE](state, { i }) {
    if (i === "all") {
      for (let key = 0; key < state.menu.children.length; key++) {
        if (state.menu.children[key].isActive === true) {
          state.menu.children[key].isActive = false
          break
        }
      }
    } else {
      state.menu.children[i].isActive = false
    }
  },
  [SET_MODULES](state, data) {
    for (let i = 0; i < state.menu.children.length; i++) {
      if (state.menu.children[i].name === "模块") {
        state.menu.children[i].children = data
        break
      }
    }
  },
  [SET_SYSTEM_MODULES](state, data) {
    let baseElement = state.menu.children.find(item => item.type === "baseElement")
    let element = state.menu.children.find(item => item.type === "element")
    let highElement = state.menu.children.find(item => item.name === "高级组件")
    element = element.children.concat(highElement.children)
    element = element.concat(baseElement.children)
    let chileElement = element.find(item => item.typeId === data.type)
    if (!chileElement) {
      return
    }
    let list = chileElement.children
    for (let i = 0; i < list.length; i++) {
      if (list[i].attribute.options.isSystemComponent && !list[i].attribute.options.isDefaultComponent) {
        list.splice(i, 1)
        i--
      } else {
        list[i].attribute.options.componentTypeId = data.type
        list[i].attribute.options.name = chileElement.name
        list[i].attribute.options.componentTypeName = chileElement.type
      }
    }
    let localStylesLen = list.length
    data.list.forEach((rect, index) => {
      let param = {
        name: rect.title,
        cover: rect.cover,
        thumbnail: "",
        attribute: {
          ...JSON.parse(rect.content)
        }
      }
      if (!param.attribute.options) {
        param.attribute.options = {}
      }
      param.attribute.options.isSystemComponent = true
      param.attribute.options.isIndependenceComponent = chileElement.type === "swiperComponent" ? false : true
      param.attribute.options.componentTypeId = data.type
      param.attribute.options.componentTypeName = chileElement.type
      param.attribute.options.encId = rect.encId
      param.attribute.options.name = chileElement.name
      param.attribute.options.isDefaultComponent = false
      list.push(param)
    })
    Vue.set(chileElement, "children", list)
    Vue.set(chileElement, "localStylesLen", localStylesLen)
  },
  [SET_MODULE_TYPES](state, data) {
    Vue.set(state.menu, "moduleTypes", data)
    let component = state.menu.children.find(item => item.name === "组件")
    let highComponent = state.menu.children.find(item => item.name === "高级组件")
    let baseComponent = state.menu.children.find(item => item.name === "基础")
    component = component.children.concat(highComponent.children, baseComponent.children)
    data.forEach(item => {
      let curComponent = component.find((componentItem) => {
        if(item.name.indexOf(componentItem.name) > -1){
          if(componentItem.name === "文本"){
            if(componentItem.type === "cxText"){
              return componentItem
            }
          }else {
            return componentItem
          }
        }
      })
      if (curComponent) {
        curComponent.typeId = item.encId
        item.componentType = curComponent.componentType || curComponent.type
      }
    })
  },
  [SET_OTHER_MODULE_TYPES](state, data) {
    Vue.set(state.menu, "otherTypes", data)
  },
  [UPDATE_MENU](state, data) {
    Vue.set(state.menu.children[0].children[data.child_index], "subs", data.newMenu)
  },
  [UPDATE_MODULE](state, data) {
    Vue.set(state, "myModules", data.myModules)
  },
  [SET_APPLICATION](state, data) {
    Vue.set(state.menu.children[2].children[data.child_index], "children", data.newMenu)
  },
  [SET_LIST_PAGE_TYPES](state, data) {
    Vue.set(state.menu, "listPageTypes", data)
  },
  [SET_DETAIL_PAGE_TYPES](state, data) {
    Vue.set(state.menu, "detailPageTypes", data)
  }
}
